module.exports = __webpack_public_path__ + "static/media/degas-11.515e6afb.jpeg";